import axios from 'axios';
import {EditableUserData, User} from "@/scripts/types/users";

export const getUser: () => Promise<User> = async () => {
    const url = '/api/users/me';
    const response = await axios.get(url);

    return response.data as User;
};

export const updateUser = async (data: EditableUserData): Promise<User> => {
    const url = '/api/account';

    return (await axios.patch(url, data)).data as User;
};
